function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "-100 -100 700 700"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  fill: "#f5baec",
  r: 184,
  "data-original": "#808080",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  fill: "#eb9ee2",
  r: 136,
  "data-original": "#676767",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  fill: "#d46dcb",
  r: 88,
  "data-original": "#4e4e4f",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("g", {
  fill: "#333"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 40,
  fill: "#64225d",
  "data-original": "#333333",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("rect", {
  height: 16,
  rx: 8,
  transform: "matrix(.117 -.993 .993 .117 -127.916 784.156)",
  width: 16.11,
  x: 368.886,
  y: 456,
  fill: "#64225d",
  "data-original": "#333333",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("rect", {
  height: 16.11,
  rx: 8,
  transform: "matrix(.117 -.993 .993 .117 275.653 580.101)",
  width: 16,
  x: 456,
  y: 127.004,
  fill: "#64225d",
  "data-original": "#333333",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("rect", {
  height: 16,
  rx: 8,
  transform: "matrix(.117 -.993 .993 .117 71.61 176.527)",
  width: 16.11,
  x: 127.004,
  y: 40,
  fill: "#64225d",
  "data-original": "#333333",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("rect", {
  height: 16.11,
  rx: 8,
  transform: "matrix(.117 -.993 .993 .117 -331.968 380.571)",
  width: 16,
  x: 40,
  y: 368.886,
  fill: "#64225d",
  "data-original": "#333333",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("path", {
  d: "m320 224c85.678 0 155.844 67.693 159.822 152.4a7.983 7.983 0 0 0 7.978 7.6 8.017 8.017 0 0 0 8-8.408c-4.4-93.158-81.572-167.592-175.8-167.592h-46.919l13.541-16.25a151.548 151.548 0 0 1 134.578-53.671l9.918 1.167a8 8 0 0 0 8.88-7.011 8 8 0 0 0 -7.011-8.88l-9.918-1.167a167.5 167.5 0 0 0 -148.739 59.319l-22.22 26.664a47.816 47.816 0 0 0 -28.11 12.09v-28.261c0-85.678 67.693-155.844 152.4-159.822a7.983 7.983 0 0 0 7.6-7.978 8.017 8.017 0 0 0 -8.408-8c-93.158 4.4-167.592 81.572-167.592 175.8v46.919l-16.249-13.54a152.058 152.058 0 0 1 -53.672-134.579l1.167-9.918a8 8 0 0 0 -7.011-8.882 8 8 0 0 0 -8.88 7.011l-1.167 9.918a167.5 167.5 0 0 0 59.319 148.741l26.664 22.22a47.816 47.816 0 0 0 12.09 28.11h-28.261c-85.678 0-155.844-67.693-159.822-152.4a7.983 7.983 0 0 0 -7.978-7.6 8.017 8.017 0 0 0 -8 8.408c4.4 93.158 81.572 167.592 175.8 167.592h46.919l-13.541 16.25a151.542 151.542 0 0 1 -134.578 53.671l-9.918-1.167a8 8 0 0 0 -8.882 7.011 8 8 0 0 0 7.011 8.88l9.918 1.167a169.844 169.844 0 0 0 19.846 1.166 167.424 167.424 0 0 0 128.895-60.485l22.22-26.664a47.816 47.816 0 0 0 28.11-12.09v28.261c0 85.678-67.693 155.844-152.4 159.822a7.983 7.983 0 0 0 -7.6 7.978 8.017 8.017 0 0 0 8.408 8c93.158-4.4 167.592-81.572 167.592-175.8v-46.919l16.249 13.54a152.058 152.058 0 0 1 53.672 134.579l-1.167 9.918a8 8 0 0 0 7.011 8.88 8 8 0 0 0 8.88-7.011l1.167-9.918a167.5 167.5 0 0 0 -59.319-148.739l-26.664-22.22a47.816 47.816 0 0 0 -12.09-28.11zm-32 32a32 32 0 1 1 -32-32 32.036 32.036 0 0 1 32 32z",
  fill: "#64225d",
  "data-original": "#333333",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("rect", {
  height: 16,
  rx: 8,
  width: 16,
  x: 400,
  y: 16,
  fill: "#64225d",
  "data-original": "#333333",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("rect", {
  height: 16,
  rx: 8,
  width: 16,
  x: 16,
  y: 96,
  fill: "#64225d",
  "data-original": "#333333",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("rect", {
  height: 16,
  rx: 8,
  width: 16,
  x: 96,
  y: 480,
  fill: "#64225d",
  "data-original": "#333333",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("rect", {
  height: 16,
  rx: 8,
  width: 16,
  x: 480,
  y: 400,
  fill: "#64225d",
  "data-original": "#333333",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("rect", {
  height: 16,
  rx: 8,
  width: 16,
  x: 64,
  y: 480,
  fill: "#64225d",
  "data-original": "#333333",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("rect", {
  height: 16,
  rx: 8,
  width: 16,
  x: 480,
  y: 432,
  fill: "#64225d",
  "data-original": "#333333",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("rect", {
  height: 16,
  rx: 8,
  width: 16,
  x: 432,
  y: 16,
  fill: "#64225d",
  "data-original": "#333333",
  style: {},
  className: ""
}), /*#__PURE__*/React.createElement("rect", {
  height: 16,
  rx: 8,
  width: 16,
  x: 16,
  y: 64,
  fill: "#64225d",
  "data-original": "#333333",
  style: {},
  className: ""
}))));

export default __webpack_public_path__ + "static/media/blackHole.7b13d308.svg";
export { SvgComponent as ReactComponent };